import { Method } from './apireftypes';
import { Util } from '../fasades/util';

export class GenCodeCurl {
    private method: Method;
    private url:    string;
    private body?:  object;

    constructor(method: Method, url: string, body?: object) 
    {
        this.method = method;
        this.url = url;
        this.body = body;
    }

    generate(): string 
    {
        let text = `curl ${ Util.getTigerAPIUrl() }${ this.url } \\\n`;
        if (this.method !== Method.Get) {
            text += `    -X ${this.method} \\\n`;
        }
        text += `    -H "Authorization: Bearer $TIGER_API_KEY"`;

        if (this.body !== undefined) {
            text += `\\\n`;
            text += `    -H 'Content-Type: application/json' \\\n`;

            const jsonString = JSON.stringify(this.body, null, 2);
            const escapedJson = jsonString
                .replace(/\\/g, '\\\\')  // Escape backslashes first
                .replace(/"/g, '\\"')    // Escape double quotes
                .replace(/\$/g, '\\$');  // Escape dollar signs
            text += `    -d "${escapedJson}"`;
        }

        return text;
    }
}
